import {isPlatformServer} from '@angular/common';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {lastValueFrom, Observable, of, ReplaySubject} from 'rxjs';
import {LandingServiceBrokerService} from '../landing-service-broker/landing-service-broker.service';
import {UserService} from '../user/user.service';

@Injectable({
  providedIn: 'root',
})
export class VpnService {
  constructor(
    @Inject(PLATFORM_ID) platform: object,
    private readonly userService: UserService,
    private readonly landingServiceBroker: LandingServiceBrokerService,
  ) {
    this.isServerSide = isPlatformServer(platform);
    if (!VpnService.isTestMode && !this.isServerSide) {
      // Check status immediately
      this.checkStatus();
      // Then check every 10 seconds
      window.setInterval(this.checkStatus.bind(this), 10000);
    } else {
      this._vpnStatus.next(!this.isServerSide);
    }
  }

  private readonly isServerSide: boolean;
  private currentStatus: boolean | undefined = undefined;

  static isTestMode = false;

  public async heartbeat() {
    try {
      const user = await this.userService.userPromise;
      if (!user) return false;
      const services = await this.landingServiceBroker.getByOrganizationName(user?.organization?.name);
      if (!services) return false;
      return await lastValueFrom(services.StatusService.checkConnectionToDataEnclave());
    } catch (_) {
      return false;
    }
  }

  public checkStatus() {
    Promise.race([
      this.heartbeat(),
      new Promise<boolean>((resolve, _reject) => {
        window.setTimeout(() => resolve(false), 5000);
      }),
    ]).then(status => {
      if (status !== this.currentStatus) {
        this._vpnStatus.next(status);
      }
      this.currentStatus = status;
    });
  }

  public get isConnected(): Observable<boolean> {
    if (this.isServerSide) return of(false);
    return this._vpnStatus.asObservable();
  }
  private readonly _vpnStatus: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
}
